import { useCallback, useState, useEffect } from 'react';

import { useEventListener } from 'usehooks-ts';

interface Size {
  width: number;
  height: number;
}

function useElementSize<T extends HTMLElement = HTMLDivElement>(
  dependencies: boolean[] = []
): [(node: T | null) => void, Size] {
  const [ref, setRef] = useState<T | null>(null);
  const [size, setSize] = useState<Size>({
    width: 0,
    height: 0
  });

  const handleSize = useCallback(() => {
    setSize({
      width: ref?.scrollWidth || 0,
      height: ref?.scrollHeight || 0
    });
  }, [ref?.scrollHeight, ref?.scrollWidth]);

  useEventListener('resize', handleSize);

  useEffect(() => {
    handleSize();
  }, [
    ref?.scrollHeight,
    ref?.scrollWidth,
    ...(dependencies.length > 0 ? dependencies : [])
  ]);

  return [setRef, size];
}

export default useElementSize;
